import React, { ReactNode } from "react";

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "outline" | "ghost" | "danger" | string;
  className?: string;
}

export const Button = ({
  children,
  size = "md",
  variant = "primary",
  className = "",
  disabled,
  ...rest
}: ButtonProps) => {
  const baseStyles =
    "blue-gold-glass-btn pulse font-semibold tracking-wide text-white relative select-none transition-all overflow-hidden rounded-lg";

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  const variants: Record<string, string> = {
    primary: "",
    outline:
      "bg-transparent border border-white/30 text-white hover:bg-white/10",
    ghost: "bg-transparent text-white hover:bg-white/10",
    danger: "bg-red-600 hover:bg-red-700",
  };

  return (
    <button
      disabled={disabled}
      className={`
        ${baseStyles}
        ${sizes[size]}
        ${variants[variant] || ""}
        ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        ${className}
      `}
      {...rest}
    >
      {/* Content */}
      <span className="relative z-20">{children}</span>

      {/* Premium V2 layers */}
      <div className="inner-glow"></div>
      <div className="gold-shimmer"></div>
      <div className="gold-cross"></div>
    </button>
  );
};

export default Button;
